export default "__VITE_ASSET__r6$3hFre__"